<template>
  <div class="monthly-trend">
    <div class="trend-tabs">
      <button 
        v-for="tab in tabs" 
        :key="tab.key"
        :class="['tab-button', { active: activeTab === tab.key }]"
        @click="activeTab = tab.key"
      >
        {{ tab.label }}
      </button>
    </div>
    
    <div class="trend-chart">
      <Echart ref="trendChart" :options="currentChartOptions" style="height: 100%; width: 100%" />
    </div>
  </div>
</template>

<script>
import { putAction } from '@/api/manage'

export default {
  name: 'MonthlyTrend',
  data() {
    return {
      activeTab: 'water',
      tabs: [
        { key: 'water', label: this.$t('用水量') },
        { key: 'payment', label: this.$t('缴费金额') }
      ],
      loading: false,
      waterData: [],
      paymentData: [],
      months: [],
      url: {
        list: '/jeecg-charge/meter/waterAnalysis/waterUseAndPay'
      }
    }
  },
  computed: {
    currentChartOptions() {
      const data = this.activeTab === 'water' ? this.waterData : this.paymentData
      const unit = this.activeTab === 'water' ? 'm³' : this.$t('元')
      const color = this.activeTab === 'water' ? '#0096ff' : '#50E3C2'

      return {
        grid: {
          top: '15%',
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.months,
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)'
            }
          },
          axisLabel: {
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: 9,
            interval: 1
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)'
            }
          },
          axisLabel: {
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: 9,
            formatter: (value) => {
              if (this.activeTab === 'payment' && value >= 10000) {
                return (value / 10000).toFixed(1) + this.$t('万')
              }
              return value + unit
            }
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.1)'
            }
          }
        },
        series: [{
          name: this.activeTab === 'water' ? this.$t('用水量') : this.$t('缴费金额'),
          type: 'line',
          smooth: true,
          symbol: 'circle',
          symbolSize: 4,
          lineStyle: {
            width: 2,
            color: color
          },
          itemStyle: {
            color: color,
            borderColor: '#fff',
            borderWidth: 1
          },
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0,
                color: `${color}80`
              }, {
                offset: 1,
                color: `${color}10`
              }]
            }
          },
          data: data
        }]
      }
    }
  },
  watch: {
    activeTab() {
      this.$nextTick(() => {
        if (this.$refs.trendChart) {
          // this.$refs.trendChart.refresh()
        }
      })
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  },
  methods: {
    init() {
      this.queryMonthlyTrend()
    },
    queryMonthlyTrend() {
      this.loading = true
      putAction(this.url.list, {}).then((res) => {
        if (res.success) {
          this.months = res.result.monthStrList || []
          this.waterData = res.result.waterUseList || []
          this.paymentData = res.result.payMoneyList || []
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.monthly-trend {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
  
  .trend-tabs {
    display: flex;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
    
    .tab-button {
      flex: 1;
      padding: 0.375rem 0.75rem;
      background: rgba(0, 150, 255, 0.1);
      border: 1px solid rgba(0, 150, 255, 0.2);
      border-radius: 4px;
      color: rgba(255, 255, 255, 0.7);
      font-size: 0.75rem;
      cursor: pointer;
      transition: all 0.3s ease;
      
      &.active {
        background: rgba(0, 150, 255, 0.3);
        border-color: rgba(0, 150, 255, 0.5);
        color: #fff;
      }
      
      &:hover:not(.active) {
        background: rgba(0, 150, 255, 0.2);
        border-color: rgba(0, 150, 255, 0.3);
      }
    }
  }
  
  .trend-chart {
    flex: 1;
    min-height: 0;
  }
}

@media (max-width: 768px) {
  .monthly-trend {
    .trend-tabs {
      .tab-button {
        padding: 0.25rem 0.5rem;
        font-size: 0.625rem;
      }
    }
  }
}
</style>